/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { Typography } from "@mui/material";

const DNVLoginComponentEditor = () => {
    return (
        <div className='simplicity-editor-frame'>
            <Typography 
                variant='body1'
                color={"text.secondary"}
                className='simplicity-component-parameters'
            >
                This component has no parameters.
            </Typography>
        </div>
    );
};

DNVLoginComponentEditor.displayName = "DNVLoginComponentEditor";
export { DNVLoginComponentEditor };
